export const STUDENT_PROGRESS_NARROW_TOGGLED = 'STUDENT_PROGRESS_NARROW_TOGGLED';

export const toggleNarrowStudentProgress = () => ({
  type: STUDENT_PROGRESS_NARROW_TOGGLED
});
